export default {
    computed: {
       categories() {return this.$store.getters.getCurrentCategories }
    }
}